<script setup lang="ts">
import { Toaster } from '@laam/ui/base';
import { LaamIcon } from '@laam/ui/icons';
import Card from '~/components/campus-program/Card.vue';
</script>

<template>
	<div class="min-h-screen flex flex-col">
		<!-- Header -->
		<Toaster :show-close="false" :position="'top'" />
		<div
			class="campus-programs--header gap-8xl lg:px-md px-3xl lg:py-md py-xl flex bg-white border-b border-gray-200"
		>
			<div class="hidden lg:flex justify-between w-full">
				<LaamIcon variant="laam_logo_complete" class="h-[36px] ml-xl" />
			</div>
			<h1 class="lg:hidden block text-md font-semibold">Sign up now</h1>
		</div>
		<div class="main lg:py-[54px] bg-gray-50 grow flex flex-col">
			<div
				class="lg:max-w-[1216px] lg:bg-transparent mx-auto grow flex flex-col"
			>
				<div class="flex items-start gap-7xl lg:flex-row flex-col grow">
					<Card
						class="hidden lg:flex left--info-card px-3xl py-7xl flex-col gap-3xl flex-[1]"
					>
						<div>
							<h2 class="display-xs font-semibold">
								Join the LAAM Campus Program for Exclusive Offers
							</h2>
							<h5 class="text-xs font-medium">
								Celebrating the education community with special discounts and
								offers.
							</h5>
						</div>
						<div>
							<h2 class="text-md font-semibold mb-xl">Our Promise!</h2>
							<div class="flex flex-col gap-xl">
								<p class="text-xs text-gray-700">
									Thy privacy we hold most dear,
								</p>
								<p class="text-xs text-gray-700">
									To none shall we thy secrets rear.
								</p>
								<p class="text-xs text-gray-700">
									No unauthorized eyes shall see,
								</p>
								<p class="text-xs text-gray-700">
									Thy personal data, safe with thee!
								</p>
							</div>
						</div>
					</Card>
					<slot />
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.main {
	/* Add styles for large screens here */
	@media (min-width: 768px) {
		background-image: url('https://cdn.shopify.com/s/files/1/2337/7003/files/bg-onboarding-172958400428317.png');
		background-size: cover;
		background-position: center;
		background-repeat: repeat-y;
	}
}
</style>
